var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noAudioDialog"},[_c('div',{staticClass:"titleGrid"},[_c('div',{staticClass:"close-btn",on:{"click":function($event){return _vm.hide('Close')}}},[_c('i',{staticClass:"icon-popup-close"})])]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("视频中没有音频数据，无法进行字幕识别。")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1deec4d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subtitle/dialogs/noAudioDialog.vue
// module id = null
// module chunks = 